import backgroundRed from "@/assets/background_red.svg";
import decoratorGreen from "@/assets/decorator_green.svg";
import PatternBackground from "@/components/PatternBackground";

/** "See you!" page after a student enrolls (mockup: olive squiggle, title,
 *  payment instructions). */
export default function Created() {
  return (
    <PatternBackground background={backgroundRed}>
      <div className="w-full max-w-2xl rounded-[40px] border-2 border-ink bg-white px-6 py-10 text-center shadow-sm sm:px-12 sm:py-14">
        <img
          src={decoratorGreen}
          alt=""
          aria-hidden
          className="mx-auto w-64 sm:w-80"
        />
        <h1 className="mt-6 font-sans text-4xl text-ink sm:text-5xl">
          ¡Nos vemos!
        </h1>
        <p className="mx-auto mt-8 max-w-md font-sans text-base font-light text-ink/70 sm:text-lg">
          Tienes un cupo reservado en el curso.{" "}
          <strong className="block font-semibold text-ink">
            Se te enviará un correo con el detalle de la actividad
          </strong>
        </p>
      </div>
    </PatternBackground>
  );
}
